module.exports = __webpack_public_path__ + "static/media/80erfinaldemo-01.57d11c12.svg";